import { PERMISSIONS_ENUM } from '../enum/permission.enum';

export const ALL_PERMISSIONS = [
  // Dashboard
  PERMISSIONS_ENUM.SHOP_ADMIN_DASHBOARD_ACCESS,

  // Promotion Programs
  PERMISSIONS_ENUM.SHOP_ADMIN_PROMOTION_ADD,
  PERMISSIONS_ENUM.SHOP_ADMIN_PROMOTION_EDIT,
  PERMISSIONS_ENUM.SHOP_ADMIN_PROMOTION_ACCESS,
  PERMISSIONS_ENUM.SHOP_ADMIN_PROMOTION_DELETE,
  PERMISSIONS_ENUM.SHOP_ADMIN_PROMOTION_APPROVE,
  PERMISSIONS_ENUM.SHOP_ADMIN_PROMOTION_VIEW_DETAIL,
  PERMISSIONS_ENUM.SHOP_ADMIN_PROMOTION_TOGGLE_STATUS,

  // Voucher Management
  PERMISSIONS_ENUM.SHOP_VOUCHER_MANAGEMENT_ADD,
  PERMISSIONS_ENUM.SHOP_VOUCHER_MANAGEMENT_EDIT,
  PERMISSIONS_ENUM.SHOP_VOUCHER_MANAGEMENT_DELETE,
  PERMISSIONS_ENUM.SHOP_VOUCHER_MANAGEMENT_ACCESS,
  PERMISSIONS_ENUM.SHOP_VOUCHER_MANAGEMENT_APPROVE,
  PERMISSIONS_ENUM.SHOP_VOUCHER_MANAGEMENT_VIEW_DETAIL,
  PERMISSIONS_ENUM.SHOP_VOUCHER_MANAGEMENT_TOGGLE_STATUS,

  // Order Management
  PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_ACCESS,
  PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_EXPORT,
  PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_CANCEL,
  PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_CONFIRM,
  PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_VIEW,
  PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_VIEW_DETAIL,

  // Shop Management
  PERMISSIONS_ENUM.SHOP_MANAGEMENT_EXPORT,
  PERMISSIONS_ENUM.SHOP_MANAGEMENT_ACCESS,
  PERMISSIONS_ENUM.SHOP_MANAGEMENT_EDIT_SHOP,
  PERMISSIONS_ENUM.SHOP_MANAGEMENT_EDIT_BAGDE,
  PERMISSIONS_ENUM.SHOP_MANAGEMENT_EXPORT_LEGAL,
  PERMISSIONS_ENUM.SHOP_MANAGEMENT_TOGGLE_STATUS,
  PERMISSIONS_ENUM.SHOP_MANAGEMENT_VIEW_DASHBOARD,

  // Product Management
  PERMISSIONS_ENUM.SHOP_PRODUCT_MANAGEMENT_BLOCK,
  PERMISSIONS_ENUM.SHOP_PRODUCT_MANAGEMENT_ACCESS,
  PERMISSIONS_ENUM.SHOP_PRODUCT_MANAGEMENT_DELETE,
  PERMISSIONS_ENUM.SHOP_PRODUCT_MANAGEMENT_VIEW_DETAIL,
  PERMISSIONS_ENUM.SHOP_PRODUCT_MANAGEMENT_EXPORT_PRODUCT_LIST,

  // Refund Management
  PERMISSIONS_ENUM.SHOP_REFUND_MANAGEMENT_REJECT,
  PERMISSIONS_ENUM.SHOP_REFUND_MANAGEMENT_ACCESS,
  PERMISSIONS_ENUM.SHOP_REFUND_MANAGEMENT_APPROVE,
  PERMISSIONS_ENUM.SHOP_REFUND_MANAGEMENT_VIEW_DETAIL,

  // Banner Management
  PERMISSIONS_ENUM.BANNER_SHOP_EDIT,
  PERMISSIONS_ENUM.BANNER_SHOP_DELETE,
  PERMISSIONS_ENUM.BANNER_SHOP_ACCESS,
  PERMISSIONS_ENUM.BANNER_SHOP_ADD,
  PERMISSIONS_ENUM.BANNER_SHOP_STATUS,
  PERMISSIONS_ENUM.BANNER_SHOP_VIEW,

  // FAQ Assistant
  PERMISSIONS_ENUM.CHAT_FAQ_ADD,
  PERMISSIONS_ENUM.CHAT_FAQ_EDIT,
  PERMISSIONS_ENUM.CHAT_FAQ_VIEW,
  PERMISSIONS_ENUM.CHAT_FAQ_DELETE,
  PERMISSIONS_ENUM.CHAT_FAQ_ACCESS,

  // Soctrip Chat
  PERMISSIONS_ENUM.CHAT_SUPPORT_ACCESS,
  PERMISSIONS_ENUM.CHAT_SUPPORT_VIEW_CHAT,
  PERMISSIONS_ENUM.CHAT_SUPPORT_VIEW_HISTORY,
  PERMISSIONS_ENUM.CHAT_SUPPORT_DELETE_HISTORY,
  PERMISSIONS_ENUM.CHAT_SUPPORT_BASIC_CHAT_ACTION,
  PERMISSIONS_ENUM.CHAT_SUPPORT_SETTING_VIEW,
  PERMISSIONS_ENUM.CHAT_SUPPORT_SETTING_EDIT,

  // Suppliers
  PERMISSIONS_ENUM.SHOP_SUPPLIER_MANAGEMENT_ACCESS,
  PERMISSIONS_ENUM.SHOP_SUPPLIER_MANAGEMENT_VIEW_DETAIL,
  PERMISSIONS_ENUM.SHOP_SUPPLIER_MANAGEMENT_ADD,
  PERMISSIONS_ENUM.SHOP_SUPPLIER_MANAGEMENT_EDIT,
  PERMISSIONS_ENUM.SHOP_SUPPLIER_MANAGEMENT_DELETE,

  // Connect Sellers
  PERMISSIONS_ENUM.SHOP_CONNECT_SELLER_MANAGEMENT_ACCESS,
  PERMISSIONS_ENUM.SHOP_CONNECT_SELLER_MANAGEMENT_VIEW_DETAIL,
  PERMISSIONS_ENUM.SHOP_CONNECT_SELLER_MANAGEMENT_ADD,
  PERMISSIONS_ENUM.SHOP_CONNECT_SELLER_MANAGEMENT_EDIT,
  PERMISSIONS_ENUM.SHOP_CONNECT_SELLER_MANAGEMENT_DELETE,
  PERMISSIONS_ENUM.SHOP_SALE_CAMPAIGN_MANAGEMENT_VIEW_DETAIL,
  PERMISSIONS_ENUM.SHOP_SALE_CAMPAIGN_MANAGEMENT_EDIT,

  // Promote Sections
  PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_ACCESS,
  PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_ORDER_ARRANGE,
  PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_ADD_TAB,
  PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_EDIT_TAB,
  PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_ADD_PRODUCT,
  PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_TOGGLE_STATUS,
  PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_DELETE_PRODUCT,
  PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_DELETE_TAB,
];
